export enum ModuleEntityType {
  TENANT = 'tenant',
  DEMAND = 'demand',
  CONTRACT_DEMAND = 'contract-demand',
  SOURCING_CASE = 'sourcing-case',
  SUPPLIER = 'supplier',
  COMPANY = 'company',
  ORDER = 'order',
  CONTRACT = 'contract',
  PURCHASE_REQUISITION = 'purchase-requisition',
  COMMODITY = 'commodity',
  COMMODITY_GROUP = 'commodity-group',
  GL_ACCOUNT = 'gl-account',
  NEGOTIATION_CASE = 'negotiation-case',
  USER = 'user',
  RULE = 'rule',
  SOURCING_PROJECT = 'sourcing-project',
  PURCHASE_ORDER = 'purchase-order',
}

export type ModuleEntity = `${ModuleEntityType}`;
